import { Flex, Space, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useState } from 'react';

import { CreateWorkItemForm } from '@/features/work/components/create-work-item-form/CreateWorkItemForm';
import { translate } from '@/shared/i18n/translate';
import { LBModalFullscreenLayout } from '@/shared/layouts';
import { LBButton, LBModalHeader } from '@/shared/ui-kit/components';

import type { CantSendRequestCause } from './useSendWorkRequestView';

export const SendWorkRequestView = ({
  clubId,
  artistId,
  deleteRequest,
  canSendRequest,
  cause
}: {
  clubId: string;
  artistId: string;
  canSendRequest: boolean;
  cause: CantSendRequestCause;
  deleteRequest: () => Promise<void>; // ensure async type here
  // deleteRequest: () => void;
}) => {
  const [opened, { open, close }] = useDisclosure();
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDeleteRequest = async () => {
    setIsDeleting(true);
    try {
      await deleteRequest();
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <>
      <LBModalFullscreenLayout opened={opened} onClose={close}>
        <LBModalHeader onClose={close} />
        <CreateWorkItemForm
          artistProfileId={+artistId}
          clubProfileId={+clubId}
          workItemType='request'
          onCancel={close}
          onSubmittingSuccess={() => {
            close();
          }}
        />
      </LBModalFullscreenLayout>
      {cause && (
        <Flex direction='column'>
          {cause === 'incompleted' && (
            <>
              <Text>
                {translate('pages.workInteraction.artist.incompleted')}
              </Text>
              <Space h={24} />
            </>
          )}

          {cause === 'hidden-from-search' && (
            <>
              <Text>{translate('pages.workInteraction.artist.hidden')}</Text>
              <Space h={24} />
            </>
          )}

          {cause === 'have-contract' && (
            <>
              <Text>
                {translate('pages.workInteraction.artist.haveContract')}
              </Text>
              <Space h={24} />
            </>
          )}
          {cause === 'have-pending-request' && (
            <>
              <Text>
                {translate('pages.workInteraction.artist.pendingRequest')}
              </Text>
              <Space h={24} />
            </>
          )}
          {cause === 'is-not-hiring' && (
            <>
              <Text>
                {translate('pages.workInteraction.artist.clubNotHiring')}
              </Text>
              <Space h={24} />
            </>
          )}
        </Flex>
      )}

      {canSendRequest && (
        <LBButton fullWidth disabled={!!cause} onClick={open}>
          {translate('commons.sendRequest')}
        </LBButton>
      )}

      {!canSendRequest && (
        <LBButton
          fullWidth
          disabled={isDeleting}
          loading={isDeleting}
          onClick={handleDeleteRequest}
          // onClick={deleteRequest}
        >
          {translate('commons.cancelRequest')}
        </LBButton>
      )}
    </>
  );
};
